export const EditorMode = {
  /** Can not move elements around */
  kiosk: 1,
  /** Can move elements, has less toolbar options than normal */
  simple: 2,
  /** Limited toolbar options, can select animation presets */
  normal: 3,
  /** Full editor access, can custimize animations */
  advanced: 4,
  /** Superuser access. Allow for use of more powerful editor tools */
  'super': 5,
};
